

































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Decimal } from 'decimal.js';
import { BehaviorSubject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import device from 'current-device';
import BaseComponent from '@/components/base-component.vue';
import { toNumber } from '@/helpers/toNumber';
import { decimalFormat } from '@/helpers/decimalFormat';
import { isEdge, isSafari, isIOS } from '@/helpers/checkBrowser';

const removeDots = (str) => str.replace(/([\.])/g, '');
const replaceCommaWithDot = (str) => str.replace(/([\,])/, '.');
const replaceDotWithComma = (str) => str.replace(/(\.)/g, ',');
const removeAdditionalCommas = (value) =>
  value.replace(/([\d]*[\,]{1}[\d]*)([\,]*)/g, '$1');
const removeNoDigits = (value) => value.replace(/([^\d|\.|\,]*)/g, '');
const event = (name) => {
  const evt = document.createEvent('Event');
  evt.initEvent(name, true, true);
  return evt;
};
const useInputEvent = () => device.mobile() || device.tablet() || isSafari();
const emulatedChangeEvent = (element, listener): void => {
  let internalVal;
  element.addEventListener(
    'focus',
    (e) => {
      internalVal = e.srcElement.value;
    },
    false,
  );
  element.addEventListener(
    'blur',
    (e) => {
      if (internalVal !== e.srcElement.value) {
        listener(e);
      }
    },
    false,
  );
};
@Component({
  components: {
    BaseComponent,
  },
})
export default class InputMoney extends BaseComponent {
  get maxlength(): string {
    const dots = !!this.displayValue ? this.displayValue.match(/\./g) : [];
    const dotsTotal = !!dots ? dots.length : 0;
    const SEPARATOR_LENGTH = 1;
    const maxlength =
      SEPARATOR_LENGTH +
      toNumber(this.decimalPlaces) +
      toNumber(this.digitsPlaces) +
      dotsTotal;
    return maxlength.toString();
  }
  @Prop({
    default: false,
  })
  public autoSelect: boolean;
  @Prop()
  public value: any;
  @Prop({
    default: '',
  })
  public suffix?: string;
  @Prop({
    default: '',
  })
  public label?: string;
  @Prop({
    default: '00,00',
  })
  public placeholder?: string;
  @Prop({
    default: '',
  })
  public height?: string;
  @Prop({
    default: '2',
  })
  public decimalPlaces?: string;
  @Prop({
    default: '8',
  })
  public digitsPlaces?: string;
  @Prop({
    default: false,
  })
  public singleLine?: boolean;
  @Prop({
    default: false,
  })
  public outline?: boolean;
  @Prop({
    default: false,
  })
  public hideDetails?: boolean;
  @Prop({
    default: false,
  })
  public required?: boolean;
  @Prop({
    default: () => [],
  })
  public rules?: any[];
  @Prop({
    default: null,
  })
  public tabIndex?: any[];
  @Prop({
    default: false,
  })
  public disabled?: boolean;
  @Prop({
    default: false,
  })
  public selectionOnFocus?: boolean;
    @Prop({
    default: false,
  })
  public loading?: boolean;

  @Prop()
  public appendOuterIcon?: string;

  @Prop()
  public prependInnerIcon?: string;

  public hasFocus: boolean = false;

  public onFocusValue: number;
  public valueDigited: boolean = false;
  public displayValue: string = '';

  public lastFocusedInputName: string = '';

  public lastClick: BehaviorSubject<any> = new BehaviorSubject(false);

  @Watch('value')
  public onChangeValue() {
    // if (!this.value || !toNumber(this.value)) {
    //   this.displayValue = '0,00';
    //   return;
    // }

    if (toNumber(this.value) !== toNumber(this.displayValue, true)) {
      this.valueDigited = false;
    }
    if (this.hasFocus) {
      let valDecimal;
      valDecimal = new Decimal(this.value);
      valDecimal = valDecimal.toFixed();
      valDecimal = replaceDotWithComma(valDecimal);
      valDecimal = this._decimalFix(valDecimal);
      this.displayValue = valDecimal;

       const input: any = this.$refs.input;
       if(input != null)
          input.internalValue = this.displayValue;
    } else {
      const value = !!this.value ? this.value : 0;
      let valDecimal = this._formatBigDecimal(value);
      valDecimal = this._decimalFix(valDecimal);
      this.displayValue = valDecimal;

       const input: any = this.$refs.input;
       if(input != null)
         input.internalValue = this.displayValue;
    }
  }

  @Watch('displayValue')
  public onChangeDisplayValue(val) {
    if (
      toNumber(this.onFocusValue) === toNumber(val, true) &&
      (!val || !toNumber(val))
    ) {
      return;
    }
    val = this._decimalFix(val);

    const input: any = this.$refs.input;
    if(input != null)
       input.internalValue = val;
    this.$emit('input', toNumber(val, true));
  }

  public onKeypress(e: any): void {
    if (!e.isTrusted) {
      const formatedValue = this._decimalFix(e.srcElement.value);
      e.srcElement.value = formatedValue;
      e.srcElement._value = formatedValue;
      return;
    }

    const possibleKeys = [
      ',',
      '.',
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
    ];
    const NOT_FOUND = -1;
    const typedKey = useInputEvent() ? e.data : e.key;
    if (!!typedKey && possibleKeys.indexOf(typedKey) !== NOT_FOUND) {
      this.valueDigited = true;
    }

    if (!e.srcElement.value) {
      this.valueDigited = true;
      return;
    }

    const formatedValue = this._decimalFix(e.srcElement.value);
    e.srcElement.value = formatedValue;
    this.displayValue = formatedValue;
    if (useInputEvent()) {
      e.srcElement.dispatchEvent(event('input'));
    } else {
      e.srcElement.dispatchEvent(event('keypress'));
      e.srcElement.dispatchEvent(event('keyup'));
    }
  }

  public onChange(val): void {
    const unFormatedVal = this._decimalFix(val);
    if (
      !this.valueDigited ||
      this.onFocusValue === toNumber(unFormatedVal, true)
    ) {
      return;
    }

    this.$emit('input', toNumber(unFormatedVal, true));
    this.$emit('change', toNumber(unFormatedVal, true));
  }

  public beforeMount() {
    this.lastClick.pipe(throttleTime(1000)).subscribe((evt) => {
      if (!evt) {
        return;
      }
      setTimeout(() => {
        evt.target.select();
        evt.target.setSelectionRange(0, 9999);
      }, 20);
    });
    this.onChangeValue();
  }

  public mounted(): void {
    this.addInputEvents();
  }

  public onFocus(e: any): void {
    this.hasFocus = true;
    this.setFocusValue(e.target.value);
    const formatedValue = this._decimalFix(e.srcElement.value);
    e.srcElement.value = formatedValue;
    e.srcElement._value = formatedValue;
    this.$emit('focus', e);

    if (!!this.autoSelect) {
      this.lastClick.next(e);
    }
  }

  public onBlur(e: any): void {
    this.hasFocus = false;
    this.onChangeValue();
    const formatedValue = this._decimalFix(e.srcElement.value);
    e.srcElement.value = formatedValue;
    e.srcElement._value = formatedValue;
    this.$emit('blur', e);
  }

  public _decimalFix(val: any): string {
    if (!val) {
      return '';
    }
    const splitWithComma = (value) => {
      const dots = value.match(/\./g);
      const dotsTotal = !!dots ? dots.length : 0;
      const digitsTotal = toNumber(this.digitsPlaces) + dotsTotal;
      const regExpDigits = new RegExp(
        `([\\d|\\.]{${digitsTotal}})([\\d]+)`,
        'g',
      );

      return value.replace(regExpDigits, '$1,$2');
    };

    const limitDecimalPlaces = (value) => {
      const regExpDecimal = new RegExp(
        `([\\d]*[\\,][\\d]{1,${this.decimalPlaces}})(.*)`,
        'g',
      );
      return value.replace(regExpDecimal, '$1');
    };

    const addThousandSeparators = (value) => {
      const revertStr = (str) =>
        str
          .split('')
          .reverse()
          .join('');
      const splitedVal = value.split(',');
      const matchs = revertStr(splitedVal[0]).match(/([\d]{1,3})/g);
      if (!!matchs) {
        splitedVal[0] = matchs
          .reverse()
          .map(revertStr)
          .join('.');
      }

      return splitedVal.join(',');
    };

    let returnVal = val;
    returnVal = returnVal.toString();
    returnVal = removeNoDigits(returnVal);
    returnVal = removeDots(returnVal);

    const NOT_FOUND = -1;
    if (returnVal.indexOf(',') === NOT_FOUND) {
      returnVal = splitWithComma(returnVal);
    }

    returnVal = removeAdditionalCommas(returnVal);
    returnVal = limitDecimalPlaces(returnVal);
    returnVal = addThousandSeparators(returnVal);

    return returnVal;
  }

  private addInputEvents(): void {
    const input: any = this.$refs.input;
    if (!!input && !!input.$el) {
      const inputs = input.$el.getElementsByTagName('input');
      if (!!inputs.length) {
        const input = inputs[0];

        if (isEdge() || isIOS()) {
          emulatedChangeEvent(input, (e) => this.onChange(e.srcElement.value));
        } else {
          input.addEventListener(
            'change',
            (e) => this.onChange(e.srcElement.value),
            false,
          );
        }

        input.addEventListener('blur', (e) => this.onBlur(e), false);
        input.addEventListener('focus', (e) => this.onFocus(e), false);

        if (useInputEvent()) {
          input.addEventListener('input', (e) => this.onKeypress(e), false);
        } else {
           input.addEventListener('keypress', (e) => this.onKeypress(e), false);
           input.addEventListener('keyup', (e) => this.onKeypress(e), false);
        }
      }
    }
  }

  private setFocusValue(value): void {
    this.onFocusValue = toNumber(value, true);
  }

  private _formatBigDecimal(val): string {
    let valToDecimal = replaceCommaWithDot(val.toString());
    valToDecimal = removeNoDigits(valToDecimal);

    let valDecimal;
    valDecimal = new Decimal(valToDecimal);
    valDecimal = valDecimal.toNumber();
    valDecimal = decimalFormat(valDecimal, this.decimalPlaces);

    return valDecimal;
  }

  private getUniqueId(): string {
    const random = Math.random()
      .toString(36)
      .substr(2, 16);
    return `id-${random}`;
  }

  private onClickAppendOuter(evt){
    this.$emit('click:append-outer', evt);
  }

  private hasAppendOuterSlot() {
    return !!this.$slots['append-outer'];
  }
}
